import { InjectionToken } from '@angular/core';
import { CoreConfig } from './core.config';

export const CORE_CONFIG = new InjectionToken<CoreConfig>('CoreConfig');
export interface ErrorSimulationConfig {
  enabled: boolean;
}

export const ERROR_SIMULATION_CONFIG = new InjectionToken<ErrorSimulationConfig>('ErrorSimulationConfig');
